import React from 'react';
import classnames from 'classnames';

import { useMedia } from 'util/event';
import { TagResource } from 'util/api/swaggerApi/data-contracts';

import Link from 'components/atoms/Link';
import Icon from 'components/atoms/Icon';
import TagList from 'components/molecules/TagList';

import IconArrow from 'images/icon/arrow-right-up.inline.svg';

import styles from './index.module.css';

interface CardNewsProperty {
	className?: string;
	linkType?: 'internal' | 'external';
	linkTo?: string;
	layout?: 'horizontal' | 'vertical';
	width?: 'narrow' | 'wide';
	image: string;
	date: string;
	category?: string;
	title: string;
	subtitle: string;
	tagsData?: TagResource[];
}

const CardNews: React.FC<CardNewsProperty> = ({
	className,
	linkType = 'internal',
	linkTo,
	layout = 'horizontal',
	width = 'wide',
	image,
	date,
	category,
	title,
	subtitle,
	tagsData,
}) => {
	const media = useMedia();

	return (
		<Link
			className={classnames(
				styles.wrapper,
				styles[`layout-${layout}`],
				styles[`width-${width}`],
				className,
			)}
			type={linkType}
			to={linkTo}
		>
			{layout === 'vertical' && (
				<>
					<div className={styles.image}>
						<img src={image} alt="" />
					</div>
					<div className={styles.content}>
						<p className={styles.date}>{date}</p>
						<div className={styles.titleWrapper}>
							<p className={styles.title}>{title}</p>
							<Icon className={styles.arrow} src={IconArrow} />
						</div>
						<p className={styles.subtitle}>{subtitle}</p>
					</div>
				</>
			)}
			{layout === 'horizontal' && (
				<>
					<div className={styles.image}>
						<img src={image} alt="" />
					</div>
					<div className={styles.content}>
						<div className={styles.top}>
							<p className={styles.date}>{date}</p>
							{category && <p className={styles.category}>{category}</p>}
						</div>
						<p className={styles.title}>{title}</p>
						<p className={styles.subtitle}>{subtitle}</p>
						{tagsData && (
							<TagList className={styles.tagWrapper} tagSize="small" tagsData={tagsData} />
						)}
					</div>
					{media === 'desktop' && <Icon className={styles.arrow} src={IconArrow} />}
				</>
			)}
		</Link>
	);
};

export default CardNews;
